/**
 * Loop Archive Custom JS. Mainly for covering the banner
 */
(function ($) {
	const archiveSerial = ".archive-serial";
	let $archiveSerial = $(archiveSerial);

	function scaleBanners() {
		$archiveSerial.each(function () {
			let $container = $(this).find(".thumb");
			let $image = $container.find("img");
			if ($container.length && $image.length) {
				scaleImageContainer($container, $image);
				$container.addClass("is-loaded");
			}
		});
	}

	$(window).on("load resize", function () {
		scaleBanners();
	});
})(jQuery);
